// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"06355913","496":"61c85ab5","610":"751392d1"}[chunkId] + ".js";
};